import { PlaySerializer } from "./PlaySerializer";
import FootballState from "../../../../../sports/football/state/football-state";

export class UpdateContextPlaySerializer extends PlaySerializer {
    applicable(play) {
        return play.historyContains(FootballState.UpdateContext);
    }

    serialize(play, serializationContext) {
        //We're crating two different serialized plays. One for each value updated in the context.
        //TODO: think about detecting a context change automatically and generate the plays accordingly.
        return [
            ...super.serialize(play, {
                ...serializationContext,
                isSpotUpdate: true
            }),

            ...super.serialize(play, {
                ...serializationContext,
                isDownUpdate: true
            })
        ];
    }
}
